
import Comparer from '../../../quaity/compliance/Comparer';

import css from './TnaRow.module.css'
import { getCellClass, isSame } from '../../../../../services/utils/tna';

function TnaRow({
  ata,
  additionalData,
  showDiff,
  diffRow,
  onEditClick,
}) {

  const removeNotCoveredNA = (str) => {
    if (!str) return '';
    return str
      .replace(/Not covered in this module/g, '')
      .replace(/n\/a/g, '')
      .trim();
  }

  return (
    <tr key={ata.ataId}>
      <td className={css.center}>{ata.ataNo}</td>
      <td className={css.left}>
        {ata.ataTitle}
        <i>{additionalData?.notes && <p>{additionalData.notes}</p>}</i>
      </td>

      {showDiff && (
        <td className={css.td}>
          <div className={css.content}>
            {isSame(removeNotCoveredNA(diffRow?.fromComponents), removeNotCoveredNA(diffRow?.toComponents)) ? (
              <div className={css.nd}>ND</div>
            ) : (
              <Comparer
                oldString={removeNotCoveredNA(diffRow?.fromComponents) || ''}
                newString={removeNotCoveredNA(diffRow?.toComponents) || ''}
              />
            )}
          </div>
        </td>
      )}

      <td className={getCellClass(css, additionalData?.components, css.left)} style={{ whiteSpace: 'pre-line' }}>
        {additionalData?.components || ''}
      </td>

      {showDiff && (
        <td className={css.td}>
          <div className={css.content}>
            {isSame(removeNotCoveredNA(diffRow?.fromObjectives), removeNotCoveredNA(diffRow?.toObjectives)) ? (
              <div className={css.nd}>ND</div>
            ) : (
              <Comparer
                oldString={removeNotCoveredNA(diffRow?.fromObjectives) || ''}
                newString={removeNotCoveredNA(diffRow?.toObjectives) || ''}
              />
            )}
          </div>
        </td>
      )}

      <td className={getCellClass(css, additionalData?.objectives, css.left)} style={{ whiteSpace: 'pre-line' }}>
        {additionalData?.objectives || ''}
      </td>

      {showDiff && (
        <td className={css.td}>
          <div className={css.content}>
            {isSame(diffRow?.maxFromLevel, diffRow?.maxToLevel) ? (
              <div className={css.nd}>ND</div>
            ) : (
              <Comparer
                oldString={diffRow?.maxFromLevel || ''}
                newString={diffRow?.maxToLevel || ''}
              />
            )}
          </div>
        </td>
      )}

      <td className={getCellClass(css, additionalData?.level, css.center)}>
        {additionalData?.level || ''}
      </td>
      <td className={getCellClass(css, additionalData?.aids?.length, css.center)}>
        {(additionalData?.aids || '').split(', ').join('\n')}
      </td>
      <td className={getCellClass(css, additionalData?.methods?.length, css.center)}>
        {(additionalData?.methods || '').split(', ').join('\n')}
      </td>
      <td className={getCellClass(css, additionalData?.duration, css.center)}>
        {additionalData?.duration ? additionalData.duration.slice(0, 5) : ''}
      </td>
      <td className={css.center}>
        <button className={css.editButton} onClick={() => onEditClick(ata)}>
          <i className={`fa-solid fa-pen ${css.orange}`}> </i>
        </button>
      </td>
    </tr>
  );
}

export default TnaRow;